var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { row: "", "justify-center": "" } },
    [
      _c(
        "v-dialog",
        {
          attrs: { persistent: "", "max-width": "500px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-form",
            {
              staticClass: "collaborators__form-dialog",
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.onSubmit($event)
                }
              }
            },
            [
              _c("v-card-title", { staticClass: "collaborators__form-title" }, [
                _c("span", [_vm._v(_vm._s(_vm.modalTitle))])
              ]),
              _c(
                "v-card-text",
                { staticClass: "pt-0" },
                [
                  _c(
                    "v-layout",
                    { attrs: { wrap: "" } },
                    [
                      _c("v-text-field", {
                        attrs: {
                          label: "Nombres",
                          error: _vm.$v.sellerName.$error,
                          "error-messages": _vm.sellerNameErrorMessages,
                          maxlength: 40
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.sellerName.$touch()
                          },
                          keypress: _vm.onlyLetters
                        },
                        model: {
                          value: _vm.sellerName,
                          callback: function($$v) {
                            _vm.sellerName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "sellerName"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          label: "Apellidos",
                          error: _vm.$v.sellerLastName.$error,
                          "error-messages": _vm.sellerLastNameErrorMessages,
                          maxlength: 40
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.sellerLastName.$touch()
                          },
                          keypress: _vm.onlyLetters
                        },
                        model: {
                          value: _vm.sellerLastName,
                          callback: function($$v) {
                            _vm.sellerLastName =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "sellerLastName"
                        }
                      }),
                      _c(
                        "div",
                        { staticClass: "collaborators__select-document" },
                        [
                          _c("v-select", {
                            attrs: {
                              items: _vm.documentTypesCollaboratorsPage,
                              label: "Doc",
                              required: "",
                              "append-icon": "icon-triangles"
                            },
                            on: {
                              input: function($event) {
                                _vm.changeEvent(_vm.docType)
                              }
                            },
                            model: {
                              value: _vm.docType,
                              callback: function($$v) {
                                _vm.docType = $$v
                              },
                              expression: "docType"
                            }
                          }),
                          _c("v-text-field", {
                            staticClass: "collaborators__doc-number",
                            attrs: {
                              label: "Número",
                              error: _vm.$v.docNumber.$error,
                              "error-messages": _vm.docNumberErrorMessages,
                              maxlength: _vm.maxLengthDocumentNumber
                            },
                            on: {
                              input: function($event) {
                                _vm.$v.docNumber.$touch()
                              },
                              keypress: _vm.onlyNumbers,
                              keyup: _vm.validateDocNumber
                            },
                            model: {
                              value: _vm.docNumber,
                              callback: function($$v) {
                                _vm.docNumber =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "docNumber"
                            }
                          })
                        ],
                        1
                      ),
                      _c("email-autocomplete", {
                        attrs: {
                          type: "email",
                          error: _vm.$v.email.$error,
                          "error-messages": _vm.emailErrorMessagesByConsult,
                          withErrors: true,
                          label: "Correo",
                          maxlength: 100
                        },
                        on: {
                          input: function($event) {
                            _vm.$v.email.$touch()
                          },
                          keyup: _vm.validateEmail
                        },
                        model: {
                          value: _vm.email,
                          callback: function($$v) {
                            _vm.email =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "email"
                        }
                      }),
                      _c("v-text-field", {
                        attrs: {
                          type: "tel",
                          label: "Teléfono",
                          maxlength: 20
                        },
                        on: { keypress: _vm.onlyNumbers },
                        model: {
                          value: _vm.cellphone,
                          callback: function($$v) {
                            _vm.cellphone =
                              typeof $$v === "string" ? $$v.trim() : $$v
                          },
                          expression: "cellphone"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.userCategories,
                          label: "Categoría"
                        },
                        model: {
                          value: _vm.userCategory,
                          callback: function($$v) {
                            _vm.userCategory = $$v
                          },
                          expression: "userCategory"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.channels,
                          label: "Canal",
                          "return-object": ""
                        },
                        model: {
                          value: _vm.channel,
                          callback: function($$v) {
                            _vm.channel = $$v
                          },
                          expression: "channel"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.subChannels,
                          label: "Sub Canal",
                          "return-object": "",
                          disabled: _vm.loadingSubChannels || !_vm.channel
                        },
                        model: {
                          value: _vm.subChannel,
                          callback: function($$v) {
                            _vm.subChannel = $$v
                          },
                          expression: "subChannel"
                        }
                      }),
                      _c("v-select", {
                        attrs: {
                          items: _vm.groupChannels,
                          label: "Grupo Canal",
                          "return-object": "",
                          disabled: _vm.loadingGroupChannels || !_vm.subChannel
                        },
                        model: {
                          value: _vm.groupChannel,
                          callback: function($$v) {
                            _vm.groupChannel = $$v
                          },
                          expression: "groupChannel"
                        }
                      }),
                      _vm.multipleOptions
                        ? _c(
                            "div",
                            [
                              _c("v-checkbox", {
                                staticClass: "collaborators__checkbox",
                                attrs: {
                                  label: "Supervisor de equipo",
                                  disabled: _vm.conditionalIsSupervisor
                                },
                                model: {
                                  value: _vm.checkbox,
                                  callback: function($$v) {
                                    _vm.checkbox = $$v
                                  },
                                  expression: "checkbox"
                                }
                              }),
                              _vm.conditionalShowMessageSupervisor
                                ? _c(
                                    "p",
                                    {
                                      staticClass: "collaborators-message",
                                      staticStyle: { "margin-top": "-20px" }
                                    },
                                    [
                                      _vm._v(
                                        "“Si selecciona esta opción, este vendedor pasará a ser supervisor”"
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.editState
                        ? _c("div", { staticClass: "collaborators__state" }, [
                            _c("div", { staticClass: "slide__item-switch" }, [
                              _c("h3", [_vm._v("Estado")]),
                              _c(
                                "div",
                                { staticClass: "slide__switch" },
                                [
                                  _c("v-switch", {
                                    attrs: {
                                      disabled:
                                        _vm.conditionalIsSupervisor ||
                                        _vm.isTeamActiveConditional
                                    },
                                    model: {
                                      value: _vm.switchState,
                                      callback: function($$v) {
                                        _vm.switchState = $$v
                                      },
                                      expression: "switchState"
                                    }
                                  }),
                                  _vm.switchState
                                    ? _c("p", [_vm._v("Activo")])
                                    : _c("p", [_vm._v("Inactivo")])
                                ],
                                1
                              ),
                              _vm.conditionalShowMessageStatus
                                ? _c(
                                    "p",
                                    { staticClass: "collaborators-message" },
                                    [_vm._v(_vm._s(_vm.messageStatus))]
                                  )
                                : _vm._e()
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    { staticClass: "collaborators__buttons-container" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button text black uppercase",
                          nativeOn: {
                            click: function($event) {
                              return _vm.cancel($event)
                            }
                          }
                        },
                        [_vm._v("Cancelar")]
                      ),
                      _c(
                        "v-btn",
                        {
                          staticClass: "primary-button blue w110",
                          attrs: { disabled: _vm.disabled, type: "submit" }
                        },
                        [_vm._v(_vm._s(_vm.buttonName))]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f8d1d9e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f8d1d9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-seller-modal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-3f8d1d9e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/collaborators/new-seller-modal.vue
// module chunks = 4 6 7 8 9